import { getDisplayDate } from "./date-functions";

export type PubDtRow = {
    CenterNames: string[];
    AwardNumbers: string[];
    FundingGrants: string[];

    CenterNameJoined: string;
    AwardNumberJoined: string;
    FundingGrantsJoined: string;

    PubMedId: string;
    Title: string;
    Authors: string;
    AuthorsList: string[];
    PubYear: number | null;

    Journal: string;
    JournalNorm: string;
    PublicationDateUtc: string;
    PublicationDateDisplay: string;

    Doi: string;
    Pmcid: string;
    Abstract: string;

    MeshTerms: string[];
    MeshTermsJoined: string;
    Keywords: string[];
    KeywordsJoined: string;

    IsPreprint: boolean;
    MatchKey: string;
};

const MISSING_AWARD_LABEL = 'Missing award (update on PubMed)';
const MISSING_CENTER_LABEL = '-- Unknown --';

export function mapToPubDtRows(pubs: any[] | null | undefined): PubDtRow[] {
    const S = (v: any): string => String(v ?? '').trim();
    const A = (v: any): string[] => (Array.isArray(v) ? v : []).map(S).filter(Boolean);
    const J = (arr: string[]) => arr.join('; ');

    return (pubs ?? []).map((p: any) => {
        const centerNames = A(p.CenterNames ?? p.centerNames);
        const awardNumbers = A(p.AwardNumbers ?? p.awardNumbers);
        const funding = A(p.FundingGrants ?? p.fundingGrants);
        const mesh = A(p.MeshTerms ?? p.meshTerms);
        const keywords = A(p.Keywords ?? p.keywords);

        const pubDateUtc = S(p.PublicationDateUtc ?? p.publicationDateUtc);
        const pubDateDisplay = pubDateUtc ? getDisplayDate(new Date(pubDateUtc)) : '';

        const centerSingle = S(p.CenterName ?? p.centerName);
        const awardSingle = S(p.AwardNumber ?? p.awardNumber);

        const centerFinal =
            centerNames.length ? centerNames : (centerSingle ? [centerSingle] : [MISSING_CENTER_LABEL]);

        const awardFinal =
            awardNumbers.length ? awardNumbers : (awardSingle ? [awardSingle] : [MISSING_AWARD_LABEL]);

        const authorsStr = S(p.Authors ?? p.authors);
        const authorsList = authorsStr
            ? authorsStr.split(';').map(x => x.trim()).filter(Boolean)
            : [];

        const journal = S(p.Journal ?? p.journal);

        return {
            CenterNames: centerFinal,
            AwardNumbers: awardFinal,
            FundingGrants: funding,

            CenterNameJoined: J(centerFinal),
            AwardNumberJoined: J(awardFinal),
            FundingGrantsJoined: J(funding),

            PubMedId: S(p.PubMedId ?? p.pubMedId),
            Title: S(p.Title ?? p.title),
            Authors: authorsStr,
            AuthorsList: authorsList,
            PubYear: (p.PubYear ?? p.pubYear ?? null),

            Journal: journal,
            JournalNorm: journal.toLowerCase(),

            Abstract: S(p.Abstract ?? p.abstract),
            Doi: S(p.Doi ?? p.doi),
            Pmcid: S(p.Pmcid ?? p.pmcid),

            MeshTerms: mesh,
            MeshTermsJoined: J(mesh),

            Keywords: keywords,
            KeywordsJoined: J(keywords),

            PublicationDateUtc: pubDateUtc,
            PublicationDateDisplay: pubDateDisplay,

            IsPreprint: !!(p.IsPreprint ?? p.isPreprint),
            MatchKey: S(p.MatchKey ?? p.matchKey),
        };
    });
}